<template>
  <div class="col-md-12">
    <div class="success-container">
      <div class="success-icon">
        <router-link :to="{ name: 'public-homepage'}" class="col-2 header-logo"><img src="@/assets/img/logo.png"></router-link>
        <!--        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">-->
        <!--          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>-->
        <!--        </svg>-->
      </div>

      <div class="success-title">
        {{ isEmailRequestedStep ? "Vérifiez votre boîte mail" : "Votre compte a bien été créé !" }}
      </div>

      <div class="success-text">
        <template v-if="isEmailRequestedStep">
          <p class="success-text-main">
            Vous venez de recevoir un email de la part d'APFORM avec un lien de validation.
          </p>
          <p class="success-text-important">
            <strong>Veuillez consulter votre boîte mail et cliquer sur le lien pour poursuivre votre inscription.</strong>
          </p>
        </template>

        <template v-else>
          <p class="success-text-main">
            Votre inscription est terminée.
          </p>
          <p class="success-text-important">
            <strong>Vous pouvez maintenant vous connecter à votre espace candidat.</strong>
          </p>
        </template>
      </div>

      <div v-if="isEmailRequestedStep" class="success-help-box">
        <div class="success-help-icon">ℹ️</div>
        <div class="success-help-content">
          <p class="success-help-title">Email non reçu ?</p>
          <p class="success-help-text">
            Vérifiez dans vos spams, <a class="success-help-link" @click="resendEmail">recevez un nouveau lien</a> ou <a class="success-help-link" href="mailto:postmaster@apform.fr">contactez-nous</a>.
          </p>
        </div>
      </div>

      <div v-if="!isEmailRequestedStep" class="form-group mt-3">
        <router-link :to="{ name: 'public-login' }" class="btn btn-primary btn-block">
          Se connecter
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

import Header from "./Header.vue";
import AuthApi from "@/api/AuthApi";
import RouteEnum from "@/router/RouteEnum";
import Toast from "@/_helpers/AlerteHelper";

export default {
  name: "Success",
  components: {
    Header
  },
  computed: {
    isEmailRequestedStep() {
      return this.$route.query.step === "email-requested";
    },
  },
  methods: {
    login: function () {
      this.$router.push({name: RouteEnum.LOGIN});
    },
    help: function () {
      let routeData = this.$router.resolve({name: 'public-help-inscription'});
      window.open(routeData.href, '_blank');
    },
    resendEmail: function () {
      const email = this.$route.query.email;
      if (!email) {
        Toast("error", "Email introuvable. Veuillez réessayer depuis la page d'inscription.", "top-end", 4000);
        return;
      }
      AuthApi.requestSignUpEmailToken(email)
          .then(() => {
            Toast("success", "Le lien de validation a été renvoyé avec succès.", "top-end", 3000);
          })
          .catch((error) => {
            console.error(error);
            const message = error?.response?.data?.message || "Une erreur est survenue lors de l'envoi de l'email. Veuillez réessayer.";
            Toast("error", message, "top-end", 4000);
          });
    }
  },
  data() {
    return {};
  },

};
</script>

<style scoped>
.success-container {
  max-width: 600px;
  margin: 40px auto;
  padding: 40px 30px;
  text-align: center;
  background: #ffffff;
  border-radius: 12px;
}

.success-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  animation: scaleIn 0.5s ease-out;
}

.success-icon svg {
  width: 48px;
  height: 48px;
  color: white;
}

@keyframes scaleIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.success-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 24px;
  line-height: 1.3;
}

.success-text {
  margin-bottom: 32px;
}

.success-text p {
  margin-bottom: 16px;
  line-height: 1.6;
}

.success-text-main {
  font-size: 16px;
  color: #4b5563;
}

.success-text-important {
  font-size: 16px;
  color: #1f2937;
  background: rgba(203, 219, 42, 0.18);
  padding: 16px;
  border-radius: 8px;
  border-left: 4px solid #CBDB2A;
}

.success-text-important strong {
  font-weight: 600;
}

.success-text-secondary {
  font-size: 15px;
  color: #6b7280;
}

.success-help-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  text-align: left;
}

.success-help-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.success-help-content {
  flex: 1;
}

.success-help-title {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
  font-size: 15px;
}

.success-help-text {
  color: #6b7280;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

.success-help-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

.success-help-link {
  cursor: pointer;
}

@media (max-width: 768px) {
  .success-container {
    margin: 20px;
    padding: 30px 20px;
  }

  .success-title {
    font-size: 24px;
  }

  .success-icon {
    width: 70px;
    height: 70px;
  }

  .success-icon svg {
    width: 42px;
    height: 42px;
  }

  .success-text-main,
  .success-text-important {
    font-size: 15px;
  }

  .success-text-secondary {
    font-size: 14px;
  }
}
</style>
